export const mudarModeloLoja = (data) => (
    {
        type: 'loja_modelo',
        payload: data
    }
);


